// logoutUser thunk: handles logout and cross-tab sync
import { deleteUser } from './userSlice';
import { resetValues } from './GenericIdsSlice';
import { resetSessionState } from './sessionSlice';
import { cancelAllRequests } from '../../api/axiosInstance';

// Thunk for logging out and syncing across tabs
export const logoutUser = () => (dispatch) => {
    // Cancel all pending API requests immediately
    try {
        cancelAllRequests();
    } catch (error) {
        console.error('Error cancelling requests:', error);
    }

    // Get current timestamp for cross-tab sync
    const logoutTimestamp = Date.now().toString();

    // Set logout timestamp BEFORE clearing (so other tabs can detect it)
    localStorage.setItem('logout', logoutTimestamp);

    // Small delay to ensure storage event propagates to all tabs
    setTimeout(() => {

        // Clear all local storage
        localStorage.clear();

        // Reset Redux state
        dispatch(deleteUser());
        dispatch(resetValues());
        dispatch(resetSessionState());
        dispatch({ type: 'CLEAR_REDUX' });

        // Force redirect to login
        window.location.href = '/';
    }, 100);
};
